<template>
    <div id="app" class="app" :class="[
        'is-color-' + $store.color, $store.isDescending ? 'is-descending' : 'is-ascending',
        'is-background-' + $store.background,
        $store.backgroundInvert !== false ? 'is-background-invert-' + $store.backgroundInvert : false
    ]">

        <div ref="slides">
            <SlideContainer ref="slidesContainer">
                <transition name="slide" mode="out-in" :duration="{ enter: 1500, leave: 800 }" v-on:enter="pageMounted()" v-on:after-enter="pageAnimationEnd()">
                    <router-view ref="slide"/>
                </transition>
            </SlideContainer>
        </div>

        <Modal :is-open="!!$store.modalMessage" @close="$store.modalMessage = false">
            <Message :data="$store.modalMessage"></Message>
        </Modal>

        <Menu/>

        <Modal :is-open="!!$store.modalVideo" @close="$store.modalVideo = false" :background="'#000'">
            <PlayerYoutube :youtubeID="$store.modalVideo"></PlayerYoutube>
        </Modal>

        <Modal :is-open="$store.modalShare" :background="'#FFF'" :color="'#000'" @close="$store.modalShare = false">
            <Share></Share>
        </Modal>

        <Modal :is-open="!$store.isConnected" :close-enabled="false">
            <Connect></Connect>
        </Modal>

    </div>
</template>
<script>
import ScrollSlide from '@/pure/event/ScrollSlide'
import Menu from '@/components/Menu'
import Modal from '@/components/Modal'
import Message from '@/components/Message'
import PlayerYoutube from '@/components/PlayerYoutube'
import Connect from '@/components/Connect'
import Share from '@/components/Share'
import SlideContainer from '@/components/SlideContainer'
import Resize from '@/mixins/Resize'


export default
{
    name: 'app',

    mixins: [
        Resize
    ],

    components:
    {
        Menu,
        SlideContainer,
        Modal,
        Message,
        PlayerYoutube,
        Connect,
        Share
    },

    computed:
    {
        slides()
        {
            return this.$store.routes
                .filter(route => route.meta && route.meta.isSlide)
        }
    },

    watch:
    {
        $route: 'setRoute'
    },

    mounted()
    {
        this.scrollSlide = new ScrollSlide({
            parent: this.$refs.slides,
            container: this.$refs.slidesContainer.$el,
            getContent: () => this.$refs.slide ? this.$refs.slide.$el : false,
            keyboardEnabled: true
        })
        this.scrollSlide.onToTop.add(this.previousForce)
        this.scrollSlide.onToBottom.add(this.nextForce)
        this.scrollSlide.resize(this.resize.width, this.resize.height)

        this.setRoute(this.$route, { name: 'old' })

        if (window.navigator.userAgent.indexOf('MSIE') <= 0 &&
            !!navigator.userAgent.match(/Trident\/7\./))
        {
            document.body.classList.add('is-ie11')
        }
    },

    destroyed()
    {
        this.scrollSlide.dispose()
    },

    methods:
    {
        setRoute(nextRoute, lastRoute)
        {
            const lastPageID = this.$store.routes
                .findIndex(route => route.name === lastRoute.name)
            const nextPageID = this.$store.routes
                .findIndex(route => route.name === nextRoute.name)

            this.setMeta(nextRoute)

            this.$store.isDescending = nextPageID > lastPageID
            this.$store.currentSlideID = this.slides
                .findIndex(route => route.name === nextRoute.name)

            this.$nextTick(this.scrollSlide.refresh)
        },

        setMeta(route)
        {
            if (route.meta && route.meta.color)
            {
                this.$store.color = route.meta.color
            }

            if (route.meta && route.meta.background)
            {
                this.$store.background = route.meta.background
            }
            else
            {
                this.$store.background = 'white'
            }

            if (route.meta && route.meta.backgroundInvert)
            {
                this.$store.backgroundInvert = route.meta.backgroundInvert
            }
            else
            {
                this.$store.backgroundInvert = false
            }
        },

        pageMounted()
        {
            if (this.$refs.slidesContainer.$el.scrollTo)
            {
                this.$refs.slidesContainer.$el.scrollTo(0, 0)
            }
            else
            {
                // IE11 fix
                this.$refs.slidesContainer.$el.scrollTop = 0
            }

            this.scrollSlide.refresh()
        },

        pageAnimationEnd()
        {
        },

        previousForce()
        {
            const currentSlide = this.$refs.slide

            if(!currentSlide.previous || !currentSlide.previous())
            {
                const id = Math.max(this.$store.currentSlideID - 1, 0)
                this.$router.push({
                    name: this.slides[id].name
                })
            }
        },

        nextForce()
        {
            const currentSlide = this.$refs.slide

            if(!currentSlide.next || !currentSlide.next())
            {
                let id = this.$store.currentSlideID + 1

                // Loop
                if(id > this.slides.length - 1)
                {
                    id = 1
                }

                this.$router.push({
                    name: this.slides[id].name
                })
            }
        },

        onResized(w, h)
        {
            this.scrollSlide.resize(w, h)
            document.documentElement.style.setProperty('--vh', (h / 100) + 'px')
        }
    }
}
</script>
<style lang="sass">
#app

</style>
